import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";

import { User } from "../../userTypes";
import ComplianceScreeningData from "./ComplianceScreeningData";
import ComplianceScreeningDataUpdateButton from "./ComplianceScreeningDataUpdateButton";

type Props = {
  external_reference: string;
  onUserChanged: (user: User) => void;
  getUser?: any;
  updateComplianceScreeningData?: any;
};

type State = {
  processingData: Boolean;
  publicOfficial: String;
  countryOfResidence: String;
  nationality: String;
};

class ComplianceScreeningDataContainer extends React.Component<Props, State> {
  state = {
    processingData: false,
    publicOfficial: null,
    countryOfResidence: null,
    nationality: null,
  };

  updateComplianceScreeningData = async (
    publicOfficial: Boolean,
    countryOfResidence: String,
    nationality: String
  ) => {
    this.setState({ processingData: true });
    await this.props.updateComplianceScreeningData({
      variables: {
        publicOfficial,
        countryOfResidence,
        nationality,
      },
    });
    this.props.getUser.refetch();
    this.setState({ processingData: false });
  };

  setPublicOfficialState = (publicOfficial) => {
    this.setState({ publicOfficial: publicOfficial });
  };

  setCountryOfResidenceState = (countryOfResidence) => {
    this.setState({ countryOfResidence: countryOfResidence });
  };

  setNationalityState = (nationality) => {
    this.setState({ nationality: nationality });
  };

  hasUserInput = () => {
    if (
      this.state.publicOfficial === null &&
      this.state.countryOfResidence === null &&
      this.state.nationality === null
    ) {
      return false;
    }

    return (
      (this.state.publicOfficial !== this.props.getUser.user?.public_official &&
        this.state.publicOfficial !== null) ||
      (this.state.countryOfResidence !== null &&
        this.state.countryOfResidence !== "" &&
        this.state.countryOfResidence !==
          this.props.getUser.user?.country_of_residence) ||
      (this.state.nationality !== null &&
        this.state.nationality !== "" &&
        this.state.nationality !== this.props.getUser.user?.nationality)
    );
  };

  render() {
    return (
      <BOGraphQLLoader data={this.props.getUser!}>
        <ComplianceScreeningData
          user={this.props.getUser.user}
          countryOfResidence={this.setCountryOfResidenceState}
          nationality={this.setNationalityState}
          publicOfficial={this.setPublicOfficialState}
        />
        <ComplianceScreeningDataUpdateButton
          user={this.props.getUser.user}
          onUserChanged={this.props.onUserChanged}
          onClick={() => {
            this.updateComplianceScreeningData(
              this.state.publicOfficial === null
                ? this.props.getUser.user.public_official
                : this.state.publicOfficial,
              this.state.countryOfResidence
                ? this.state.countryOfResidence
                : "",
              this.state.nationality ? this.state.nationality : ""
            );
          }}
          disabled={!this.hasUserInput()}
          processingData={this.state.processingData}
        />
      </BOGraphQLLoader>
    );
  }
}

const getUserQuery = graphql<any, Props>(
  gql`
    query user($external_reference: ID) {
      user(external_reference: $external_reference) {
        public_official
        country_of_residence
        nationality
      }
    }
  `,
  {
    name: "getUser",
    options(props: Props) {
      return {
        variables: {
          external_reference: props.external_reference,
        },
      };
    },
  }
);

const updateComplianceScreeningDataMutation = graphql(
  gql`
    mutation updateComplianceScreeningData(
      $externalReference: String!
      $publicOfficial: Boolean!
      $countryOfResidence: String!
      $nationality: String!
    ) {
      update_user_compliance_screening_data(
        external_reference: $externalReference
        public_official: $publicOfficial
        country_of_residence: $countryOfResidence
        nationality: $nationality
      )
    }
  `,
  {
    name: "updateComplianceScreeningData",
    options: (props: Props) => {
      return {
        variables: {
          externalReference: props.external_reference,
        },
      };
    },
  }
);

const ComplianceScreeningDataContainerWithMutation = updateComplianceScreeningDataMutation(
  ComplianceScreeningDataContainer
);
const ComplianceScreeningDataContainerWithData = getUserQuery(
  ComplianceScreeningDataContainerWithMutation
);
export {
  ComplianceScreeningDataContainerWithData,
  ComplianceScreeningDataContainer,
};
